import { VButton, VTooltip, VTooltipContent, VTooltipTrigger } from '@vrzl/ui';
import { MessageSquarePlus } from 'lucide-react';
import { useState } from 'react';

import { ExtractionFeedbackModal } from './extractionFeedbackModal';

/**
 * Icon button that opens the feedback modal for one criterion. Disabled once
 * `feedbackSent` is true; the parent keeps track of which criteria were sent.
 */
export function CriterionFeedbackButton({
  criterionId,
  criterionName,
  criterionCode,
  eventId,
  feedbackSent,
  onFeedbackSent,
}: {
  criterionId: string;
  criterionName: string;
  criterionCode: string;
  eventId: string;
  feedbackSent: boolean;
  onFeedbackSent: (criterionId: string) => void;
}) {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const feedbackLabel = feedbackSent ? 'Feedback verzonden' : 'Feedback geven';

  return (
    <>
      <VTooltip>
        <VTooltipTrigger asChild>
          <VButton
            variant="ghost"
            size="sm"
            icon={MessageSquarePlus}
            aria-label={feedbackLabel}
            disabled={feedbackSent}
            onClick={() => setFeedbackOpen(true)}
          />
        </VTooltipTrigger>
        <VTooltipContent>{feedbackLabel}</VTooltipContent>
      </VTooltip>

      <ExtractionFeedbackModal
        open={feedbackOpen}
        onOpenChange={setFeedbackOpen}
        caseId={eventId}
        fieldName={criterionCode}
        criterionId={criterionId}
        criterionName={criterionName}
        onSent={() => onFeedbackSent(criterionId)}
      />
    </>
  );
}
